import Joi from '@hapi/joi'

export const QRTagBagWiseReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group is required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity is required`
    }),
    divisionID: Joi.number().optional().label("Division").messages({
        "any.invalid": `Select Division`
    }),
    gtnNumber: Joi.string().optional().allow("").label("GTN Number"),
    sessionNo: Joi.string().optional().allow("").label("Session No"),
    date: Joi.string().invalid("").required().label("Date").messages({
        "any.invalid": `Date is required`,
        "any.required": `Date is required`
    })
}